import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { createCustomerDumpReportApi } from "./api";
import {
    CreateCustomerDumpReportRequest,
    CustomerDumpReportReduxTypes
} from "./types";

function* createCustomerDumpReport({ payload }: CreateCustomerDumpReportRequest): SagaIterator {
    try {
        const response = yield call(createCustomerDumpReportApi, payload);
        yield put({
            type: CustomerDumpReportReduxTypes.CUSTOMER_DUMP_REPORT_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: CustomerDumpReportReduxTypes.CUSTOMER_DUMP_REPORT_ERROR,
            payload: { error: error }
        });
    }
}

export function* watchCreateCustomerDumpReport() {
    yield takeEvery(
        CustomerDumpReportReduxTypes.CUSTOMER_DUMP_REPORT,
        createCustomerDumpReport
    );
}

function* customerDumpReportSaga() {
    yield all([fork(watchCreateCustomerDumpReport)]);
}

export default customerDumpReportSaga;